import { Injectable } from '@angular/core';
import * as THREE from 'three';

@Injectable({
  providedIn: 'root',
})
export class SceneService {
  private _scene: THREE.Scene = new THREE.Scene();
  private _renderer: THREE.WebGLRenderer;
  private _camera: THREE.PerspectiveCamera;

  constructor() {}

  /**
   * Gets scene
   * @returns scene
   */
  getScene(): THREE.Scene {
    return this._scene;
  }

  /**
   * Creates camera
   * @param canvas
   * @returns camera
   */
  createCamera(canvas: HTMLElement): THREE.PerspectiveCamera {
    
    const aspectRatio = canvas.clientWidth / canvas.clientHeight;
    this._camera = new THREE.PerspectiveCamera(75, aspectRatio, 1, 1000);
    return this._camera;
  }

  /**
   * Gets camera
   * @returns camera
   */
  getCamera(): THREE.PerspectiveCamera {
    return this._camera;
  }

  /**
   * Gets renderer
   * @returns renderer
   */
  getRenderer(): THREE.WebGLRenderer {
    return this._renderer;
  }
  /**
   * Sets renderer
   * @param renderer
   */
  setRenderer(renderer: THREE.WebGLRenderer) {
    this._renderer = renderer;
  }
}
